import { cn } from "@/lib/utils";
import { User as UserType } from "./user-or-not";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

// Helper function to generate initials from a user's name
function getInitials(name: string): string {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

// Avatar component that displays user's profile picture or initials as fallback
export function UserAvatar({
  user,
  className,
}: {
  user: UserType;
  className?: string;
}) {
  return (
    <Avatar className={cn("h-9 w-9", className)}>
      <AvatarImage src={user.avatar || ""} alt="user avatar" />
      <AvatarFallback>{getInitials(user.name)}</AvatarFallback>
    </Avatar>
  );
}
